import { SnackbarVariant } from "./types";

export const DEFAULT_AUTO_HIDE_DURATION = 5000;

/** Grace period before an unhovered stack collapses. Long enough to absorb a
 *  stray mouseleave, short enough not to be felt. */
export const HOVER_CLOSE_DELAY = 60;

export const SNACKBAR_COLORS: Record<SnackbarVariant, string> = {
  success: "#178038",
  error: "#BA1A1A",
  warning: "#FB8C00",
  info: "#6750A4",
};

export const SNACKBAR_ON_COLOR = "#FFFFFF";

/** M3 elevation 3, as exported from the design file. */
export const SNACKBAR_ELEVATION =
  "0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)";

export const SNACKBAR_WIDTH = 344;
export const SNACKBAR_BORDER_RADIUS = 4;

/** Longer labels than this get their own row when actionsPlacement is "auto". */
export const INLINE_ACTION_MAX_LABEL_LENGTH = 10;

/** The stack sits over the header in the top right corner. */
export const STACK_INSET = 8;
export const STACK_GAP = 8;
export const STACK_Z_INDEX = 3000;

/** How many collapsed slivers peek out from behind the newest snackbar. */
export const MAX_COLLAPSED_SLIVERS = 2;
export const SLIVER_HEIGHT = 10;
/** Each sliver is tucked under the card above it and inset a little. */
export const SLIVER_OVERLAP = 3;
export const SLIVER_INSET = 10;
